/**
 * Organisation scope (governance ADR-037, @evo-flywheel/ui OrgScopeBar): the companies this
 * tenant's records name (people included), with their names from the gateway's reference cache. A studio or a group
 * with one company never sees the selector.
 */
import { setOrgScope } from "@evo-flywheel/ui";
import { orgFields, orgVia } from "@kit/org-scope";
import { kernel } from "../api";
import { nameOf } from "./refs";

setOrgScope({
  load: async () => {
    const orgs = await kernel<Array<{ id: string }>>("/compliance/organisations");
    return Promise.all(orgs.map(async (o) => ({ id: o.id, label: await nameOf(o.id) })));
  },
  fieldsOf: (slug) => orgFields[slug] ?? [],
  // modules with no organisation field of their own follow their parent record (C56)
  viaOf: (slug) => orgVia[slug],
});
